import { createCrudSlice, createCrudSelectors } from './CrudRedux'

const assetsSlice = createCrudSlice({
  name: 'assets',
})

export const AssetsActions = assetsSlice.actions

export const AssetsSelectors = {
  ...createCrudSelectors({ name: 'assets' }),
}

export default assetsSlice.reducer
